
import { IAText } from 'utils/interfaces/store/activities.interfaces';
import './AText.scss';

export const AText = ({ text, classStyle }: IAText) => (
  <p className={`activityAtomText activityAtomText__${classStyle}`}>{text}</p>
)
